
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom'
const SpecialEvents = () => {
    const [section, setSection] = useState("ParentsSeminar");
    useEffect(() => {

    })
    return (
        <>
            <div className="breadcrumb">
                <h2>Special Events</h2>
                <ul>
                    <li><Link to="/"> Home <i className="fas fa-angle-right"></i> </Link></li>
                    <li>|</li>
                    <li>Events & Activities</li>
                    <li>|</li>
                    <li>Special Events</li>
                </ul>
            </div>
            <div className="inner_page faculty_inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="d-flex">
                                <button className={section === "ParentsSeminar" ? 'active' : ''} onClick={() => setSection("ParentsSeminar")}>Parents Seminar</button>
                                <button className={section === "KindergartenStudents" ? 'active' : ''} onClick={() => setSection("KindergartenStudents")}>Kindergarten Students</button>
                                <button className={section === "SeminarPosco" ? 'active' : ''} onClick={() => setSection("SeminarPosco")}>Seminar Posco</button>
                                <button className={section === "InvestitureCeremony" ? 'active' : ''} onClick={() => setSection("InvestitureCeremony")}>Investiture Ceremony</button>
                                <button className={section === "Inaugration" ? 'active' : ''} onClick={() => setSection("Inaugration")}>Inaugration</button>
                                <button className={section === "StaffMeet" ? 'active' : ''} onClick={() => setSection("StaffMeet")}>Staff Meet</button>
                            </div>
                        </div>
                    </div>
                    {section === "ParentsSeminar" && (
                        <div className="row">
                            <div className="col-md-12"><h3 className="heading">Parents Seminar</h3></div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps5.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps5.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps6.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps6.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps7.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps7.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps8.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps8.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps9.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps9.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/ps10.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/ps10.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                    {section === "KindergartenStudents" && (
                        <div className="row">
                            <div className="col-md-12">
                                <h3 className="heading">Kindergarten Students</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/kinter_garten_1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/kinter_garten_1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/kinter_garten_2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/kinter_garten_2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                    {section === "SeminarPosco" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Seminar Posco</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-5.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-5.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-6.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-6.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sp-7.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sp-7.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                    {section === "InvestitureCeremony" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Investiture Ceremony</h3>
                            </div>

                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau5.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau5.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau6.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau6.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau7.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau7.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau8.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau8.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau9.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau9.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau10.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau10.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>


                        </div>
                    )
                    }
                    {section === "Inaugration" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Inaugration</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau5.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau5.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau6.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau6.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau7.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau7.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau8.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau8.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau9.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau9.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/inau10.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/inau10.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                    {section === "StaffMeet" && (
                        <div className="row g-3">
                            <div className="col-md-12">
                                <h3 className="heading">Staff Meet</h3>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sm1.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sm1.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sm2.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sm2.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sm3.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sm3.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                            <div className="col-lg-4 col-md-6 col-12">
                                <a data-magnify="gallery" data-src="" data-group="a" href="images/sm4.jpg">
                                    <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/sm4.jpg" class="img-fluid mx-auto d-block bordered_img" alt="St. Francis School, Amritsar" />
                                </a>
                            </div>
                        </div>
                    )
                    }
                </div>
            </div>
        </>
    )
}

export default SpecialEvents
